import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=6d096497"
import script from "./app-sidebar.vue?vue&type=script&lang=js"
export * from "./app-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d096497')) {
      api.createRecord('6d096497', component.options)
    } else {
      api.reload('6d096497', component.options)
    }
    module.hot.accept("./app-sidebar.vue?vue&type=template&id=6d096497", function () {
      api.rerender('6d096497', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/utils-components/widgets/app-sidebar.vue"
export default component.exports